<template>
  <div class="flex flex-col items-center justify-center h-full gap-2">
    <slot />
  </div>
</template>
